import request from '@/utils/request'
const apiPath = '/course/courseSubjectRepairPlan'
import { downloadBlob } from '@/utils/download'
const courseSubjectRepairPlanApi = {
  /**
   * 新增【课程管理】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【课程管理】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【课程管理】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 
   * 查看【课程管理】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【课程管理】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  deleteBatch(data) {
    return request.post(apiPath + '/setDeleted', data, { isFormData: 1 })
  }
}
export default courseSubjectRepairPlanApi
